import { Heading } from '@chakra-ui/react';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import AccountDataTableHandler from '../../containers/dataTableHandlers/debitOperations/addNewAccount/AccountDataTableHandler';
import GeneralInformationFormHandler from '../../containers/formHandlers/debitOperations/addNewAccount/GeneralInformationFormHandler';
import NewAccountApplicantFormHandler from '../../containers/formHandlers/debitOperations/addNewAccount/NewAccountApplicantFormHandler';

const tabHeaders = [
  'Général',
  'Demandeur',
  'Compte',
];
const tabContents = [
  <GeneralInformationFormHandler />,
  <NewAccountApplicantFormHandler />,
  <AccountDataTableHandler />,
];


const AddNewAccountPage = () => {
  const orientation = CC.useBreakpointValue(
    { 
      base: 'horizontal',
    }, 
    { 
      fallback: 'md', 
    }, 
  ) as "horizontal" | "vertical";
  
  return (
    <>
      <Heading size="md" mb={'2rem'}>
        Nouveau Compte
      </Heading>
      <CustomTabs orientation={orientation} tabHeaders={tabHeaders} tabContents={tabContents} />
    </>
  )
}

export default AddNewAccountPage